"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeleteRequestObservable = exports.createDeleteRequestObservableV2 = exports.createPatchRequestObservable = exports.createPutRequestObservable = exports.createGetRequestObservable = exports.createGetRequestObservableV2 = exports.createPostRequestObservable = exports.requestWithRetry = exports.resolveResponse = exports.retryFailedRequest = exports.createAxiosRequestConfig = exports.TradeHttpErrorCode = void 0;
const axios_1 = __importDefault(require("axios"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const dataRetrive_1 = require("../dataRetrive");
const Error_1 = require("../error/Error");
var TradeHttpErrorCode;
(function (TradeHttpErrorCode) {
    TradeHttpErrorCode[TradeHttpErrorCode["tokenUnAuthorized"] = -401] = "tokenUnAuthorized";
    TradeHttpErrorCode[TradeHttpErrorCode["TradeUnAuthorized"] = -402] = "TradeUnAuthorized";
    TradeHttpErrorCode[TradeHttpErrorCode["swapUnAuthorized"] = -403] = "swapUnAuthorized";
    TradeHttpErrorCode[TradeHttpErrorCode["traderUnAuthorized"] = -405] = "traderUnAuthorized";
})(TradeHttpErrorCode || (exports.TradeHttpErrorCode = TradeHttpErrorCode = {}));
function createAxiosRequestConfig(url, headers = {}, params = {}, needCommonParams = true) {
    if (headers === null) {
        headers = {};
    }
    if (!headers["Content-Type"]) {
        headers["Content-Type"] = "application/json";
    }
    let fullParams = params;
    const queryString = url.split("?")[1];
    if (needCommonParams && (!queryString || !queryString.includes("client_id="))) {
        const commonParam = (0, dataRetrive_1.getTradeDependencyInstance)().getRunTimeHost().commonParam || {};
        fullParams = Object.assign(Object.assign({}, commonParam), params);
    }
    const config = {
        headers: headers,
        params: fullParams,
    };
    return config;
}
exports.createAxiosRequestConfig = createAxiosRequestConfig;
function retryFailedRequest(err) {
    if (err.status === 500 && err.config && !err.config.__isRetryRequest) {
        err.config.__isRetryRequest = true;
        return (0, axios_1.default)(err.config);
    }
    throw err;
}
exports.retryFailedRequest = retryFailedRequest;
function resolveResponse(observable) {
    return observable.pipe((0, operators_1.map)((res) => {
        const parseData = res;
        if (!parseData) {
            const info = JSON.stringify(res) || `${res}`;
            throw {
                code: 3841,
                message: `formatter code message error: \n${info}`,
                data: res,
            };
        }
        if ("code" in parseData) {
            if (parseData.code === 0) {
                return parseData.data;
            }
            throw res;
        }
        else if ("status" in parseData) {
            if (parseData.status === 0) {
                return parseData.data;
            }
            throw res;
        }
        else if (parseData.data) {
            return parseData.data;
        }
        return parseData;
    }));
}
exports.resolveResponse = resolveResponse;
function requestWithRetry(getRequestObservable, options = {}) {
    let retryCount = 0;
    return (0, rxjs_1.of)(0)
        .pipe((0, operators_1.switchMap)(() => getRequestObservable()))
        .pipe((0, operators_1.retryWhen)((errors) => {
        return errors.pipe((0, operators_1.switchMap)((error, index) => {
            retryCount++;
            let errorStr = error;
            if (error && typeof error === "object") {
                errorStr = JSON.stringify(error);
            }
            const errorMsg = `requestWithRetry name:${options.name} retryCount:${retryCount} maxRetryCount:${options.maxRetryCount} index:${index} error:${errorStr}`;
            (0, dataRetrive_1.getTradeDependencyInstance)().log(dataRetrive_1.LogLevel.LEVEL_ERROR, "requestWithRetry", errorMsg);
            if (options.maxRetryCount && retryCount > options.maxRetryCount) {
                throw error;
            }
            if (options.onRetry) {
                options.onRetry(retryCount, errorStr);
            }
            if (retryCount < 10) {
                return (0, rxjs_1.of)(0).pipe((0, operators_1.delay)(retryCount * 1000));
            }
            return (0, rxjs_1.of)(0).pipe((0, operators_1.delay)(10000));
        }));
    }))
        .pipe((0, operators_1.tap)(() => {
        retryCount = 0;
    }));
}
exports.requestWithRetry = requestWithRetry;
function processRespFirst(ob, parseCallback) {
    // 为ECONNABORTED错误重试的次数
    let retryCountForECONNABORTED = 0;
    return ob.pipe((0, operators_1.retryWhen)((errors) => errors.pipe((0, operators_1.delayWhen)((err) => {
        // 因为ECONNABORTED 报错时进行重试
        if ((err === null || err === void 0 ? void 0 : err.code) === "ECONNABORTED") {
            // 重试两次
            if (retryCountForECONNABORTED > 2) {
                throw err;
            }
            retryCountForECONNABORTED++;
            return (0, rxjs_1.timer)(300);
        }
        throw err;
    }))), (0, operators_1.map)((resp) => {
        return resp.data;
    }), (0, operators_1.map)((data) => {
        if (data && typeof data === "object" && "code" in data) {
            if (data.code === 0) {
                return parseCallback ? parseCallback(data) : data;
            }
            else {
                throw data;
            }
        }
        else {
            return parseCallback ? parseCallback(data) : data;
        }
    }), (0, operators_1.catchError)((err) => {
        throw Error_1.ErrorGenerate.formatterError(err);
    }));
}
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param body
 * @param parseCallback
 * @returns
 */
function createPostRequestObservable(url, headers, body, parseCallback, needCommonParams = true) {
    const ob = (0, rxjs_1.from)(axios_1.default.post(url, body, createAxiosRequestConfig(url, headers, undefined, needCommonParams)));
    return processRespFirst(ob, parseCallback);
}
exports.createPostRequestObservable = createPostRequestObservable;
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param params
 * @param parseCallback
 * @returns
 */
function createGetRequestObservableV2(url, headers, params, parseCallback, needCommonParams = true) {
    const ob = (0, rxjs_1.from)(axios_1.default.get(url, createAxiosRequestConfig(url, headers, params, needCommonParams)));
    return processRespFirst(ob, parseCallback);
}
exports.createGetRequestObservableV2 = createGetRequestObservableV2;
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param parseCallback
 * @returns
 */
function createGetRequestObservable(url, headers, parseCallback, needCommonParams = true) {
    return createGetRequestObservableV2(url, headers, undefined, parseCallback, needCommonParams);
}
exports.createGetRequestObservable = createGetRequestObservable;
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param body
 * @param parseCallback
 * @returns
 */
function createPutRequestObservable(url, headers, body, parseCallback, needCommonParams = true) {
    const ob = (0, rxjs_1.from)(axios_1.default.put(url, body, createAxiosRequestConfig(url, headers, undefined, needCommonParams)));
    return processRespFirst(ob, parseCallback);
}
exports.createPutRequestObservable = createPutRequestObservable;
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param body
 * @param parseCallback
 * @returns
 */
function createPatchRequestObservable(url, headers, body, parseCallback, needCommonParams = true) {
    const ob = (0, rxjs_1.from)(axios_1.default.patch(url, body, createAxiosRequestConfig(url, headers, undefined, needCommonParams)));
    return processRespFirst(ob, parseCallback);
}
exports.createPatchRequestObservable = createPatchRequestObservable;
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param params
 * @param parseCallback
 * @returns
 */
function createDeleteRequestObservableV2(url, headers, params, parseCallback, needCommonParams = true) {
    const ob = (0, rxjs_1.from)(axios_1.default.delete(url, createAxiosRequestConfig(url, headers, params, needCommonParams)));
    return processRespFirst(ob, parseCallback);
}
exports.createDeleteRequestObservableV2 = createDeleteRequestObservableV2;
/**
 * 内部方法, 外部不要直接调用, 为了兼容老版本, 暂时不设置成private
 * @param url
 * @param headers
 * @param parseCallback
 * @returns
 */
function createDeleteRequestObservable(url, headers, parseCallback, needCommonParams = true) {
    return createDeleteRequestObservableV2(url, headers, undefined, parseCallback, needCommonParams);
}
exports.createDeleteRequestObservable = createDeleteRequestObservable;
